import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";
import { sourceLabelKey } from "../../../../utils/automation-builder";

const openHref = (automation) =>
  `/coaching-portal/custom-workflows/automations/${automation.id}`;

const SharedPopover = ({ trigger, sharedWith }) => {
  const { t } = useTranslation("coaching-portal");
  const tr = (key, params) =>
    t(`emailAutomations.builder.shared.${key}`, params);
  return (
    <div
      className="ab-popover"
      role="dialog" //NOSONAR
    >
      <small>{tr("label")}</small>
      <strong>
        {tr("title", { count: sharedWith.length, trigger: trigger.name })}
      </strong>
      <ul>
        {sharedWith.map((other) => (
          <li key={other.id}>
            <span className={`ea-status ea-status--${other.status}`}>
              {t(`emailAutomations.status.${other.status}`)}
            </span>
            <span className="ab-popover__name">{other.name}</span>
            <a href={openHref(other)} target="_blank" rel="noreferrer">
              {tr("open")}
              <SvgIcon
                src="/img/new-icons/export.svg"
                useCurrentColor
                classNames="size-4 shrink-0"
                aria-hidden="true"
              />
            </a>
          </li>
        ))}
      </ul>
      <p>{tr("note")}</p>
    </div>
  );
};

SharedPopover.propTypes = {
  trigger: PropTypes.object.isRequired,
  sharedWith: PropTypes.array.isRequired,
};

// The trigger of the automation, with the warning when other automations start from the same thing
const TriggerCard = ({ definition, sharedWith }) => {
  const { t } = useTranslation("coaching-portal");
  const [open, setOpen] = useState(false);
  const tr = (key, params) =>
    t(`emailAutomations.builder.trigger.${key}`, params);
  return (
    <div className="ab-card ab-card--trigger">
      <span className="ab-card__label">{tr("label")}</span>
      <strong>{definition.name}</strong>
      <span className="ab-card__body">
        {definition.description} ·{" "}
        {tr(`source.${sourceLabelKey(definition.source)}`)}
      </span>
      {sharedWith.length > 0 ? (
        <button
          type="button"
          className="ab-shared-tag"
          aria-expanded={open}
          onClick={() => setOpen((value) => !value)}
        >
          {tr("sharedTag", {
            count: sharedWith.length,
            name: sharedWith[0].name,
            rest: sharedWith.length - 1,
          })}
        </button>
      ) : null}
      {open ? (
        <SharedPopover trigger={definition} sharedWith={sharedWith} />
      ) : null}
    </div>
  );
};

TriggerCard.propTypes = {
  definition: PropTypes.object.isRequired,
  sharedWith: PropTypes.array,
};

TriggerCard.defaultProps = { sharedWith: [] };

export default TriggerCard;
